import { Offer } from "@core/offers/types";
import { atom } from "@mongez/react-atom";

export const lessonOffersAtom = atom<{
  offers: Offer[];
  lessonId: number;
  isLoading: boolean;
  error: string | null;
  hasLoaded: boolean;
}>({
  key: "lessonOffers",
  default: {
    offers: [],
    lessonId: 0,
    isLoading: false,
    error: null,
    hasLoaded: false,
  },
});
